import React from 'react';
export const WideArrowBackward = () => /*#__PURE__*/React.createElement("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.8375 19.0001C14.5349 19.0011 14.2481 18.865 14.0575 18.6301L9.22749 12.6301H9.22749C8.92417 12.2611 8.92417 11.7291 9.22749 11.3601L14.2275 5.36005L14.2275 5.36005C14.5809 4.9348 15.2122 4.87659 15.6375 5.23005C16.0627 5.58352 16.1209 6.2148 15.7675 6.64005L11.2975 12.0001L15.6175 17.3601C15.971 17.7844 15.9136 18.4149 15.4892 18.7684C15.3065 18.9207 15.0754 19.0028 14.8375 19.0001V19.0001Z",
  fill: "currentColor"
}));